module.exports = __webpack_public_path__ + "img/csd.9bcede32.png";